import getConfig from 'next/config';
import { v4 as uuidv4 } from 'uuid';

import { emit as emitAvroEvent } from '@zapier/events-toolkit-browser';
import { isBrowser } from '@zapier/common-utils';
import { readCookie } from '@zapier/cookies';

const {
  publicRuntimeConfig: { SERVICE_NAME },
} = getConfig() || { publicRuntimeConfig: {} };

export function emitUserInteractionEvent({
  absoluteUrl,
  eventAction,
  interactionGoal,
  interactionName,
  interactionRawText,
  optionSelected,
  urlAddress,
}: {
  absoluteUrl?: string;
  eventAction: 'click' | 'open';
  interactionGoal: string;
  interactionName: string;
  interactionRawText: string;
  optionSelected: string;
  urlAddress?: string;
}) {
  if (isBrowser()) {
    emitAvroEvent(
      {
        absolute_url: absoluteUrl || location.href,
        event_action: eventAction,
        event_id: uuidv4(),
        identity_id: readCookie('zapidentity'),
        interaction_goal: interactionGoal,
        interaction_name: interactionName,
        interaction_raw_text: interactionRawText,
        option_selected: optionSelected,
        release_id: process.env.COMMIT_HASH,
        system_name: SERVICE_NAME,
        timestamp_ms: Date.now(),
        url_address: urlAddress || location.pathname,
      },
      'web_analytics.tracking.user_interaction.UserInteractionEvent'
    );
  }
}
